import {Component, computed, input} from '@angular/core';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {
  AdditionalConditionsType,
  CampaignTimeConditionsDetailsComponent,
  CampaignUserStatus,
  LoyaltyCurrencyPipe,
  getCampaignRemainingPercentileBudget,
  getCampaignRemainingRewards,
  getCampaignTotalRewards,
  Campaign
} from 'shared-lib';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-loyalty-campaign-card-promo-details',
  templateUrl: './loyalty-campaign-card-promo-details.component.html',
  styleUrls: ['./loyalty-campaign-card-promo-details.component.scss'],
  imports: [TranslocoDirective, LoyaltyCurrencyPipe, NgOptimizedImage, CampaignTimeConditionsDetailsComponent],
})
export class LoyaltyCampaignCardPromoDetailsComponent {
  campaign = input.required<Campaign>();

  campaignUserStatus = input<CampaignUserStatus>(CampaignUserStatus.ACTIVE);
  lightFont = input(false);

  activeRewardsText = computed<string>(() => {
    // TODO: Change this to monetary value check in the future
    if (this.campaign().additionalConditions?.additionalConditionsType == AdditionalConditionsType.LOYALTY) {
      return this.transloco.translate('actions.card.percentileRewardsRatio', {
        remaining: getCampaignRemainingPercentileBudget(this.campaign())
      });
    }

    return this.transloco.translate('actions.card.rewardsRatio', {
      remaining: getCampaignRemainingRewards(this.campaign()),
      total: getCampaignTotalRewards(this.campaign()),
    });
  });

  constructor(private transloco: TranslocoService) {
  }

  protected readonly AdditionalConditionsType = AdditionalConditionsType;
  protected readonly CampaignUserStatus = CampaignUserStatus;
}

interface ActionRewardsRatio {
  total: number;
  remaining: number;
}
